// AM dashboard: one fetcher per panel (each its own endpoint, so each panel
// loads and fails independently).

import { api } from '../../lib/api';
import type { BrandWindowRow } from '../../types/advertisingHome';
import type {
  AmAssets,
  AmCampaigns,
  AmContext,
  AmPeople,
  AmTopAds,
} from '../../types/amDashboard';

const qs = (am: string | undefined, extra: Record<string, string> = {}): string => {
  const p = new URLSearchParams(extra);
  if (am) p.set('am', am);
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const getAmContext = (am?: string): Promise<AmContext> =>
  api<AmContext>(`/api/advertising-home/am/context${qs(am)}`);
export const getAmCampaigns = (am?: string): Promise<AmCampaigns> =>
  api<AmCampaigns>(`/api/advertising-home/am/campaigns${qs(am)}`);
export const getAmAssets = (am?: string): Promise<AmAssets> =>
  api<AmAssets>(`/api/advertising-home/am/assets${qs(am)}`);
export const getAmPeople = (am?: string): Promise<AmPeople> =>
  api<AmPeople>(`/api/advertising-home/am/people${qs(am)}`);
export const getAmTopAds = (days: 7 | 30 | 90, am?: string): Promise<AmTopAds> =>
  api<AmTopAds>(`/api/advertising-home/am/top-ads${qs(am, { days: String(days) })}`);
export const getAmBrandWindows = (days: 7 | 30 | 90, am?: string): Promise<BrandWindowRow[]> =>
  api<BrandWindowRow[]>(`/api/advertising-home/am/brand-windows${qs(am, { days: String(days) })}`);
